import api from "../../lib/api";

const apiRoute = `/api/agencies/`;

export const getBanner = () => (dispatch) => {
  return api.get(`/api/agent/banner`).then((res) => {
    dispatch({
      type: "SET_BANNER",
      payload: res.data.data,
    });
    return res;
  });
};

export const getFilters = () => (dispatch) => {
  return api
    .get(`${apiRoute}properties/filters`)
    .then((res) => {
      const data = res?.data?.data;
      const filtersObj = data?.filters || data;
      const types = filtersObj?.types || res?.data?.types || [];
      const moreFilters = filtersObj?.moreFilters || data?.moreFilters || {};

      dispatch({
        type: "FETCH_FILTERS",
        payload: types,
        moreFilters,
      });
    })
    .catch((err) => {
      throw err;
    });
};

export const getCities = () => (dispatch) => {
  return api
    .get(`${apiRoute}cities`)
    .then((res) => {
      dispatch({
        type: "FETCH_CITIES",
        payload: res.data.data,
      });
    })
    .catch((err) => {
      throw err;
    });
};

export const getTranslations = () => (dispatch) => {
  return api
    .get(`/api/agent/translations`)
    .then((res) => {
      dispatch({
        type: "FETCH_TRANSLATIONS",
        payload: res.data.data,
      });
    })
    .catch((err) => {
      throw err;
    });
};
